import React, {Component} from 'react';
import {Button, Row, Spinner, Card, Col, Alert} from 'react-bootstrap';
import {Link} from "react-router-dom";
import configs from "../../Config.json";
import apitest from "../../Resources/api-test.json";

class DetallesEvento extends Component {
    constructor(props){
        super(props);
        this.state = {
            skuList: [],
            isFetching: true,
            page: 0,
            flag: true,
            showBtn: true,
            varPais: this.props.varPais,
            idPais: this.props.idPais,
            urlPais: this.props.urlPais,
            notFound: false,
            apitest: apitest,
        }
        this.doFetch = this.doFetch.bind(this);
        this.flipCard = this.flipCard.bind(this);
        this.makeBottom = this.makeBottom.bind(this);
        this.financial = this.financial.bind(this);
    }


    componentDidMount(){
        this.doFetch();
    }
    
    doFetch(){

    let newList = this.state.skuList;
    let nPage = this.state.page;
        this.setState({isFetching: true});

        //Consultamo un json de prueba con la estructura recomendado para los datos que faltan
        fetch(configs[0].host+'/eventsClub/getEventDetail?countryId='+this.props.location.state.idPais+'&eventId='+ this.props.location.state.eventoId +'&page='+ (parseInt(nPage)+1), { method: 'GET', headers:{"token": process.env.REACT_APP_API_TOK} })
            .then(response => {
                 if (!response.ok) {                
                     this.setState({flag: false})
                 return;
             }  
             return response.json()
         })
         .then(data => {          
             newList.push(...data.skuList);
             this.setState({skuList: newList, isFetching: false, page: parseInt(this.state.page)+1});    
         })
         .catch(err => {
             this.setState({isFetching: false});
         })

        // Descomenta para probar json con productos de prueba
        /*this.setState({
            isFetching: false,
            skuList: apitest.skuList
        })*/
    }
    makeBottom(eventType, pais) {
        var urlsForm = {}
        if(eventType === "Regalos" ) {
          urlsForm.SV = "https://forms.gle/2LD82hdsFms6B6227";
          urlsForm.GT = "https://forms.gle/VmNQ1bacamjNxGzm8";
          urlsForm.CR = "https://forms.gle/xhjeb9rxzy97rrqA8";
          urlsForm.NI = "https://forms.gle/cZE7gUqTAtjkWAnX7";
  
        }else {
          urlsForm.SV = "https://forms.gle/T2GZvNqwt941j9ENA";
          urlsForm.GT = "https://forms.gle/o9Ec8RH6aYk4FEUr5";
          urlsForm.CR = "https://forms.gle/HpZZKygeoCxa9n3JA";
          urlsForm.NI = "https://forms.gle/29uo43KEz6Ri3c1K7";
        }
    }
    
    flipCard (event){
        var element = event.currentTarget;
        if (element.className === "clubes--card-flip"){
            if(element.style.transform === "rotateY(180deg)"){
                element.style.transform = "rotateY(0deg)";
            }
            else {
                element.style.transform = "rotateY(180deg)";
            }
        }
    }
    financial(x) {
        
        var indexDecimal = x.indexOf(".");
        var decimal = x.substring( indexDecimal+1);
        // eslint-disable-next-line
        if(indexDecimal == -1) {
            return x+'.00'
        } else {
            // eslint-disable-next-line
            if (decimal.length == 1) {
                return x.substring(0,indexDecimal+1) + decimal + "0"
            }else {
                return x
            }
        }
    }

    render() {
        let skuList = this.state.skuList;
        let isFetching = this.state.isFetching;

        let eventoID = this.props.location.state.eventoId;
        let urlPais = this.props.location.state.urlPais;
        let tipoEvento = this.props.location.state.eventTypeId;
        let varPais = this.props.location.state.varPais;
        let lastPage = (Math.floor(this.props.location.state.totalItems/10))+1;
        let totalItems = this.props.location.state.totalItems;
        let date = new Date(this.props.location.state.eventoFecha);
        let eventName = this.props.location.state.eventoName.toLowerCase();
        
        const day =date.toLocaleString().split('/', 2);
        let meses =["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];

        const esto = this;

        if (skuList !== undefined && skuList.length > 0) {
        return (
        <div className="container">
                <Row className="clubes--dueno-evento">{this.props.location.state.eventoName}</Row>
                <Row className="clubes-detalles-evento">
                <div className="clubes--tipo-evento">{this.props.location.state.eventoTipo}</div>
                <div className="clubes--fecha-evento">{
                    
                    `${day[0]} de ${meses[date.getMonth()]} de ${date.getFullYear()}`
                }</div>
                </Row>
                <Row sm={12} md={3} lg={4} xl={5} xs={12} className="d-flex justify-content-flex-start clubes--start">
                    {skuList.map(
                        function(product){
                            return(
                            <div key={product.vtexId}>
                                <div className="clubes--tarjeta-producto">
                                    <Card key={product.vtexId} className="clubes--card-product">
                                            <div className="clubes--card-flip" onClick={esto.flipCard}>
                                                <div className="clubes--front">
                                                    <Card.Img className="d-flex justify-content-center" variant="top" src={product.image} />
                                                </div>
                                                <div className="clubes--back">
                                                    <p><strong>{product.itemDesc}</strong><br></br>{product.itemLargeDesc}</p>
                                                </div>
                                            </div>
                                        <Card.Body>
                                            <Card.Title className="clubes--nombre-producto">{product.itemDesc.length > 45 ? `${product.itemDesc.substring(0, 45)}`: product.itemDesc }</Card.Title>
                                            <div>
                                                <div className="clubes--resumen-producto pt-1">
                                                    <p className="clubes--resumen-producto-price"><strong>{
                                                        (varPais === "/NI/") ? esto.financial(product.price.slice(0, 3) + " " + product.price.slice(3)) : esto.financial(product.price)
                                                    }</strong></p>
                                                    <p>Solicitado: {product.quantity}</p>
                                                    {
                                                        (product.quantitySold >= product.quantity ) ? <p><strong>Regalo Completado</strong></p> : <p> Pendiente: {product.quantity - product.quantitySold}</p>
                                                    }
                                                </div>

                                                <div className="d-flex justify-content-center clubes--buttons">
                                                    <Button className="clubes--button-minus" onClick={
                                                        (e) => {
                                                            let menos = document.getElementById("quantity"+product.vtexId);
                                                            if(menos.value > product.quantitySold){
                                                                menos.value = parseInt(menos.value) - 1
                                                            }else{
                                                                return menos.value;
                                                            }
                                                        }
                                                    }>-</Button>
                                                
                                                    <input className="clubes--cantidad" type="" defaultValue="1" id={`quantity${product.vtexId}`} name="quantity" />

                                                    <Button className="clubes--button-plus" onClick={
                                                        (e) => {
                                                            let mas = document.getElementById("quantity"+product.vtexId);
                                                            if(mas.value < (product.quantity - product.quantitySold)){
                                                                mas.value = parseInt(mas.value) + 1
                                                            }else{
                                                                return mas.value;
                                                            }
                                                        }
                                                    }>+</Button>
                                                    
                                                </div>
                                            
                                            
                                            {   
                                                //De esta forma validamos si el producto esta disponible en el sitio y si esta disponible para regalo
                                                (product.quantityAvailable <= 0 || product.quantitySold >= product.quantity)
                                                //(product.quantity === product.quantitySold) 
                                                    ?<Button
                                                        className="clubes--button-no-disponible" 
                                                        size="lg"
                                                        key={product.vtexId}
                                                        disabled
                                                        >
                                                            No disponible
                                                    </Button>

                                                    :<Button
                                                    className="clubes--button-comprar"
                                                    variant="outline-danger" 
                                                    size="lg"
                                                    key={product.vtexId}
                                                    onClick={
                                                        (e) =>{
                                                            let quant = parseInt(document.getElementById("quantity"+product.vtexId).value);
                                                            let skus = product.vtexId;
                                                            let sku = product.vtexId
                                                            for (let index = 1; index < quant; index++) {
                                                                skus = skus + ',' + sku
                                                            }
                                                            window.open(`${urlPais}cart-event-list/?skus=${skus}&eventid=${eventoID}&eventType=${tipoEvento}&eventName=${eventName}`)
                                                        }   
                                                    }
                                                    >
                                                        Comprar
                                                    </Button>
 
                                            }
                                                
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </div>
                            )
                        }
                    )}
                </Row>
                {
                    lastPage ===  this.state.page  || totalItems <= 10 ?
                        null
                    :
                        isFetching ? 
                            <Row className="mt-3">
                                <Col className="d-flex justify-content-center" lg={12}>
                                    <Button
                                        className="clubes--button-mostrar-mas--disabled" 
                                        size="lg"
                                        disabled
                                    >
                                        <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                        Cargando...
                                    </Button>
                                </Col>
                            </Row>
                        
                        : 
                            <Row className="mt-3">
                                <Col className="d-flex justify-content-center" lg={12}>
                                    <Button className="clubes--button-mostrar-mas" onClick={this.doFetch}>Mostrar más</Button>
                                </Col>
                            </Row>
                }
            <hr></hr>
            <Row className="clubes--boton-regresar" >
                <Col xs={12} sm={12} lg={12} className="clubes--col mt-3 justify-content-end">
                    <Link className="btnsNav float-right bold d-flex justify-content-end" to={`${this.props.location.state.varPais}`} >Regresar a búsquedas <div className="clubes--back-icon"></div></Link> 
                </Col>
            </Row>

         </div>
        )   
        } else if(isFetching){
            return <Row className="d-flex justify-content-center align-items-center flex-column">
                    <Spinner  animation="border" role="status" variant="center">
                    <span className="sr-only">Loading...</span>
                    </Spinner>
                    <p>Agradecemos su espera...</p>
                </Row>
        } else {
            return (
                <div className="container">
                    <Row className="clubes--dueno-evento">{this.props.location.state.eventoName}</Row>
                        <Row className="clubes-detalles-evento">
                        <div className="clubes--tipo-evento">{this.props.location.state.eventoTipo}</div>
                        <div className="clubes--fecha-evento">{                  
                            `${day[0]} de ${meses[date.getMonth()]} de ${date.getFullYear()}`
                        }</div>
                    </Row>
                    <Row className="clubes--row mt-4">
                        <Alert className="w-100 mx-2" key={this.props.location.eventoID} variant={"warning"}>
                            Por el momento, el listado de regalos de este evento solo esta disponible en tiendas.
                        </Alert>
                    </Row>
                    <Row className="clubes--boton-regresar" >
                    <Col xs={12} sm={12} lg={12} className="clubes--col mt-3">
                    <Link className="btnsNav float-right bold d-flex justify-content-center align-item-center" to={`${varPais}`} >Regresar a búsquedas <div className="clubes--back-icon"></div></Link> 
                </Col>
                    </Row>
                </div>
                )
        }
    }

}

export default DetallesEvento;